import { render, staticRenderFns } from "./AuditoriasPanel.vue?vue&type=template&id=3b40dce0&scoped=true"
import script from "./AuditoriasPanel.vue?vue&type=script&lang=js"
export * from "./AuditoriasPanel.vue?vue&type=script&lang=js"
import style0 from "./AuditoriasPanel.vue?vue&type=style&index=0&id=3b40dce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b40dce0",
  null
  
)

export default component.exports